import { type IEntitiesStore } from 'entities/EntitiesExport'

export const logActivateSurveyEvent = (entities: IEntitiesStore) => {
  entities.eventLogStore.logEvent(
    'Activate Survey',
    { event_id: 'activate_survey' },
    { groupId: entities.organizationStore.id }
  )
}

export const logDeactivateSurveyEvent = (entities: IEntitiesStore) => {
  entities.eventLogStore.logEvent(
    'Deactivate Survey',
    { event_id: 'deactivate_survey' },
    { groupId: entities.organizationStore.id }
  )
}
